import * as types from "../actions/actionTypes";
import {
  orderListTable,
  runningTasksListTable,
  documentListTable,
  letterListTable,
  errorLetterListTable,
  preprocessListTable
} from "../utils/config";
import mergeDeep from "../utils/global";

const initialState = {
  orderListTable,
  runningTasksListTable,
  documentListTable,
  letterListTable,
  errorLetterListTable,
  preprocessListTable
};

const tableReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_TABLE_LIST: {
      let newState = {};
      mergeDeep(newState, state);
      if (action.origin === "documentList") {
        return { ...newState, documentListTable: action.list };
      } else if (action.origin === "orderList") {
        return { ...newState, orderListTable: action.list };
      } else if (action.origin === "runningTasks") {
        return { ...newState, runningTasksListTable: action.list };
      } else if (action.origin === "letterList") {
        return { ...newState, letterListTable: action.list };
      } else if (action.origin === "errorLetterList") {
        return { ...newState, errorLetterListTable: action.list };
      }
      return state;
    }
    case types.USER_SET_INFORMATIONS: {
      if (action.uipreferences && action.uipreferences.tables) {
        const runningTasksListTable = action.uipreferences.tables
          .runningTasksListTable
          ? action.uipreferences.tables.runningTasksListTable
          : initialState.runningTasksListTable;

        const orderListTable = action.uipreferences.tables.orderListTable
          ? action.uipreferences.tables.orderListTable
          : initialState.orderListTable;

        const documentListTable = action.uipreferences.tables.documentListTable
          ? action.uipreferences.tables.documentListTable
          : initialState.documentListTable;

        const letterListTable = action.uipreferences.tables.letterListTable
          ? action.uipreferences.tables.letterListTable
          : initialState.letterListTable;

        const errorLetterListTable = action.uipreferences.tables
          .errorLetterListTable
          ? action.uipreferences.tables.errorLetterListTable
          : initialState.errorLetterListTable;

        return {
          ...state,
          runningTasksListTable,
          orderListTable,
          documentListTable,
          letterListTable,
          errorLetterListTable
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default tableReducer;



// WEBPACK FOOTER //
// ./src/reducers/tableReducer.js